export enum UserType {
  Client = 'client',
  Vendor = 'vendor',
}
